import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { BookOpen, Receipt, User, LifeBuoy, LogOut } from "lucide-react";

const LINKS = [
  { to: "/compte/ebooks", label: "Mes eBooks", icon: BookOpen },
  { to: "/compte/commandes", label: "Mes commandes", icon: Receipt },
  { to: "/compte/profil", label: "Mon profil", icon: User },
  { to: "/compte/support", label: "Support", icon: LifeBuoy },
];

export default function AccountLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const doLogout = async () => { await logout(); nav("/"); };

  return (
    <div className="max-w-6xl mx-auto px-5 sm:px-8 py-12">
      <div className="mb-8">
        <p className="font-overline text-terracotta mb-1">Espace client</p>
        <h1 className="font-heading text-4xl text-ink tracking-tight">Bonjour, {user?.name || "cher parent"}</h1>
      </div>
      <div className="grid lg:grid-cols-[240px_1fr] gap-8">
        <aside className="space-y-1">
          {LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.to === "/compte/ebooks"}
              className={({ isActive }) => `flex items-center gap-3 px-4 py-2.5 rounded-md text-sm transition-colors ${isActive ? "bg-terracotta text-white" : "text-ink-muted hover:bg-cream"}`}
              data-testid={`account-nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}>
              <l.icon className="h-4 w-4" /> {l.label}
            </NavLink>
          ))}
          <button onClick={doLogout} className="flex items-center gap-3 px-4 py-2.5 rounded-md text-sm text-ink-muted hover:bg-cream w-full" data-testid="logout-button">
            <LogOut className="h-4 w-4" /> Déconnexion
          </button>
          {user?.role === "admin" && <Button asChild variant="outline" className="w-full mt-3 border-line"><NavLink to="/admin">Administration</NavLink></Button>}
        </aside>
        <div><Outlet /></div>
      </div>
    </div>
  );
}
